import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Heading, Text } from '@elseu/sdu-titan';
import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../components/Button/Button.js';
import { Slider } from '../../components/Slider/Slider.js';
import { useCurrentBreakpoint } from '../../utilities/useCurrentBreakpoint/useCurrentBreakpoint.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionCard = styled(Section)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0);
});
var ContentWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n  "])), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }));
});
var Header = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  max-width: calc(768px - ", ");\n  text-align: center;\n"], ["\n  width: 100%;\n  max-width: calc(768px - ", ");\n  text-align: center;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[8];
});
var CardsContainer = styled.ul(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    list-style: none;\n    padding: 0;\n    flex-direction: column;\n    gap: ", ";\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    list-style: none;\n    padding: 0;\n    flex-direction: column;\n    gap: ", ";\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", "\n  "])), theme.spacing[4], theme.spacing[16], theme.spacing[8], media.greaterThan('m')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n    "], ["\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n    "]))));
});
var StyledCard = styled.li(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var CardGroup = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: ", ";\n\n    ", "\n\n    ", "\n  "])), theme.spacing[4], media.greaterThan('s')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      grid-template-columns: repeat(2, 1fr);\n    "], ["\n      grid-template-columns: repeat(2, 1fr);\n    "]))), media.greaterThan('m')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      grid-template-columns: repeat(3, 1fr);\n    "], ["\n      grid-template-columns: repeat(3, 1fr);\n    "]))));
});
/**
 * Divides an array into chunks of the specified size.
 *
 * @param {React.ReactNode[]} array - The input array to be divided into chunks.
 * @param {number} size - The size of each chunk.
 * @returns {React.ReactNode[][]} An array containing the chunks.
 */
var chunkArray = function (array, size) {
  return Array.from({
    length: Math.ceil(array.length / size)
  }, function (_, i) {
    return array.slice(i * size, i * size + size);
  });
};
var SectionCard = function (_a) {
  var children = _a.children,
    title = _a.title,
    description = _a.description,
    button = _a.button,
    name = _a.name,
    reference = _a.reference,
    background = _a.background,
    isSlideshow = _a.isSlideshow;
  var breakpoint = useCurrentBreakpoint();
  var numberOfCards = {
    xs: 1,
    s: 2,
    m: 3,
    l: 3,
    xl: 3,
    xxl: 3
  };
  var groupedChildren = isSlideshow && chunkArray(React.Children.toArray(children), numberOfCards[breakpoint]);
  return jsx(StyledSectionCard, {
    name: name,
    reference: reference,
    background: background,
    children: jsxs(ContentWrapper, {
      children: [jsxs(Header, {
        children: [title && jsx(Heading, {
          heading: "h2",
          spaceAfter: 4,
          children: title
        }), description && jsx(Text, {
          as: "p",
          type: "paragraph",
          children: description
        })]
      }), !isSlideshow && jsx(CardsContainer, {
        children: React.Children.map(children, function (child, index) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            jsx(StyledCard, {
              children: child
            }, index)
          );
        })
      }), isSlideshow && groupedChildren && jsx(Slider, {
        align: "flex-start",
        children: groupedChildren.map(function (group, index) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            jsx(CardGroup, {
              children: group
            }, index)
          );
        })
      }), button && jsx(Button, __assign({}, button, {
        isExternal: button.external
      }))]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

export { SectionCard, StyledSectionCard };
//# sourceMappingURL=SectionCard.js.map
